import {
  type IReceiptFieldProps,
  receiptFieldComponents,
} from './receiptFieldComponents.tsx';
import { type ReceiptField } from './receiptFields.ts';

export interface IConfigurableReceiptFieldProps extends IReceiptFieldProps {
  field: ReceiptField;
}

/**
 * Renderizza il campo della ricevuta corrispondente all'identificatore
 * configurato via `RECEIPT_VISIBLE_FIELDS`.
 */
export function ConfigurableReceiptField(
  props: IConfigurableReceiptFieldProps,
) {
  const { field, ...fieldProps } = props;
  const Component = receiptFieldComponents[field];
  return <Component {...fieldProps} />;
}
